<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section">
<h1><img alt="" src="media/file0.jpg" style="width:3.19918in;height:4.67293in"/></h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?d6c14c2a